import { useCallback } from 'react'

import { useEnforceUpgrade } from 'components/billing/useEnforceUpgrade'

/** Dispatches into oap-web's CRM store via module federation (only runs on user action). */
export const useOpenStandardEmailComposerFromHost = () => {
  const enforceSmartComposer = useEnforceUpgrade('crm_smart_compose', {
    skipPreface: true,
  })

  return useCallback((recipient, onSendSuccess) => {
    enforceSmartComposer(async () => {
      try {
        const mod = await import(
          /* webpackChunkName: "oap_web_host_standard_email_composer" */
          'oap_web/HostStandardEmailComposer',
        )
        const openComposerWithChecks = mod.openStandardEmailComposerWithChecks
          ?? mod.openStandardEmailComposerFromHost

        openComposerWithChecks?.(recipient, onSendSuccess)
      } catch {
        // Remote missing/outdated — intentionally no-op.
      }
    })
  }, [enforceSmartComposer])
}
